{
  "labels": {
    "potrditevI": "Identity verification",
    "vnesiKodo": "Enter the code generated in your authenticator",
    "napacnaKoda": "The entered code is incorrect, please try again"
  },
  "buttons": {
    "potrdiK": "Confirm"
  },
  "obvestila": {
    "napakaKode": "Authentication failed! The entered code is not correct",
    "avtUspesna": "Authentication successful",
    "napaka": "Authentication failed!",
    "praznoPolje": "The code field cannot be empty!"
  }
}